(function () {
  'use strict';

  function changeLine(line, quantity) {
    var fd = new FormData();
    fd.append('line', String(line));
    fd.append('quantity', String(quantity));
    return fetch('/cart/change.js', { method: 'POST', body: fd })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function groupOf(item) {
    if (!item || !item.properties) return null;
    return item.properties._cdp_group || null;
  }

  function isFeeItem(item) {
    return item && item.handle === 'cake-customization-fee';
  }

  async function reconcileFees() {
    try {
      var cart = await fetchCart();

      // Map: group → { expectedMod, feeLines: [{line, qty}] }
      var expectedByGroup = {};
      var feeLines = [];

      cart.items.forEach(function (item, i) {
        if (isFeeItem(item)) {
          feeLines.push({ line: i + 1, group: groupOf(item), qty: item.quantity });
        } else {
          var g = groupOf(item);
          if (g) {
            var mod = parseInt(item.properties._price_modifier_total || '0', 10) || 0;
            if (!expectedByGroup[g]) expectedByGroup[g] = 0;
            expectedByGroup[g] += mod;
          }
        }
      });

      // Sum actual fee qty by group
      var actualByGroup = {};
      feeLines.forEach(function (f) {
        var key = f.group || '__orphan__';
        actualByGroup[key] = (actualByGroup[key] || 0) + f.qty;
      });

      // Detect mismatches and orphans
      var toRemove = [];
      var toAdjust = [];
      var groups = Object.keys(expectedByGroup).concat(Object.keys(actualByGroup));
      var uniqueGroups = Array.from(new Set(groups));

      uniqueGroups.forEach(function (g) {
        var expected = expectedByGroup[g] || 0;
        var actual = actualByGroup[g] || 0;
        if (g === '__orphan__' || !(g in expectedByGroup)) {
          // No cake with this group → remove all fees in it
          feeLines.filter(function (f) { return (f.group || '__orphan__') === g; }).forEach(function (f) {
            toRemove.push(f.line);
          });
        } else if (actual !== expected) {
          // Mismatch → remove all fees in this group, re-add single fee with expected qty
          feeLines.filter(function (f) { return f.group === g; }).forEach(function (f) {
            toRemove.push(f.line);
          });
          if (expected > 0) toAdjust.push({ group: g, qty: expected });
        }
      });

      if (toRemove.length === 0 && toAdjust.length === 0) return false;

      console.log('[cdp-cart] reconciling fees:', { remove: toRemove, adjust: toAdjust });

      // Remove from highest line first to avoid index shift
      toRemove.sort(function (a, b) { return b - a; });
      for (var i = 0; i < toRemove.length; i++) {
        await changeLine(toRemove[i], 0);
      }

      // Re-add correct fees
      for (var j = 0; j < toAdjust.length; j++) {
        var adj = toAdjust[j];
        if (!window.CDP_FEE_VARIANT_ID) {
          console.warn('[cdp-cart] CDP_FEE_VARIANT_ID not set, cannot re-add fee');
          break;
        }
        var fd = new FormData();
        fd.append('id', String(window.CDP_FEE_VARIANT_ID));
        fd.append('quantity', String(adj.qty));
        fd.append('properties[_cdp_group]', adj.group);
        await fetch('/cart/add.js', { method: 'POST', body: fd });
      }

      return true;
    } catch (e) {
      console.error('[cdp-cart] reconcile failed', e);
      return false;
    }
  }

  function onClick(e) {
    var btn = e.target.closest('.cdp-qty__btn');
    if (!btn) return;
    var widget = btn.closest('.cdp-qty');
    if (!widget) return;
    var delta = parseInt(btn.dataset.delta, 10) || 0;
    var line = parseInt(widget.dataset.line, 10);
    var current = parseInt(widget.dataset.quantity, 10);
    var next = Math.max(0, current + delta);
    if (next === current) return;

    var allBtns = widget.querySelectorAll('.cdp-qty__btn');
    allBtns.forEach(function (b) { b.disabled = true; });

    var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    changeLine(line, next).then(function (res) {
      if (!res.ok) {
        allBtns.forEach(function (b) { b.disabled = false; });
        console.error('Cart change failed', res.body);
        return;
      }
      var url = '/cart' + (previewId ? '?preview_theme_id=' + previewId : '');
      window.location.href = url;
    }).catch(function (err) {
      allBtns.forEach(function (b) { b.disabled = false; });
      console.error(err);
    });
  }

  document.addEventListener('click', onClick);

  function removeWithGroup(lineIndex, groupId) {
    var removeAll = [lineIndex];
    return fetchCart().then(function (cart) {
      cart.items.forEach(function (item, i) {
        if (item.properties && item.properties._cdp_group === groupId && (i + 1) !== lineIndex) {
          removeAll.push(i + 1);
        }
      });
      removeAll.sort(function (a, b) { return b - a; });
      return removeAll.reduce(function (prev, line) {
        return prev.then(function () { return changeLine(line, 0); });
      }, Promise.resolve());
    });
  }

  function onRemoveClick(e) {
    var link = e.target.closest('[data-cdp-remove]');
    if (!link) return;
    e.preventDefault();
    var line = parseInt(link.dataset.line, 10);
    var group = link.dataset.group || '';
    var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    (group ? removeWithGroup(line, group) : changeLine(line, 0)).then(function () {
      window.location.href = '/cart' + (previewId ? '?preview_theme_id=' + previewId : '');
    });
  }
  document.addEventListener('click', onRemoveClick);

  // On page load, clean any orphan fee lines, then reload if something was cleaned.
  // Path matches /cart, /es/cart, /fr/cart, etc.
  if (/(^|\/)cart\/?$/.test(window.location.pathname)) {
    reconcileFees().then(function (cleaned) {
      if (cleaned) {
        window.location.reload();
      }
    });
  }
})();
